module.exports = __webpack_public_path__ + "static/media/thegfb-mobiles.345b2b33.jpg";